// Capture the share payload from the URL hash at module load time, BEFORE
// HashRouter mounts and rewrites the hash. Two accepted forms:
//
//   #c=<base64url>                  — the original share-link format
//   #/create/<type>?c=<base64url>   — kept after SharedCharacterGate routes
//                                     to the creator, so the URL bar stays
//                                     directly re-shareable.
//
// We read `window.location.hash` eagerly because once HashRouter mounts it
// may normalize the hash and the gate's useEffect would miss the payload.

function extractShareHash(): string | null {
  if (typeof window === 'undefined') return '';
  const raw = window.location.hash;
  if (raw.startsWith('#c=')) return raw.slice(3);
  // Look for `?c=<hash>` inside a hash-routed URL.
  const q = raw.indexOf('?');
  if (q !== -1) {
    const params = new URLSearchParams(raw.slice(q + 1));
    const c = params.get('c');
    if (c) return c;
  }
  return null;
}

export const initialShareHash: string | null = extractShareHash();
